// @flow
import * as React from "react"
import Collapse from "react-collapse"
import { compose, withStateHandlers, type HOC } from "recompose"
import withOnMount from "hoc/withOnMount"
import { SubGroupWrap, CollapsiblePanelTitle } from "./styled"
import ArrowIcon from "assets/icons/ArrowIcon"

const CollapsiblePanel = ({
  group,
  toggleCollapse,
  isCollapsed,
  center,
  children,
}) => {
  const rotationCondition = isCollapsed ? "up" : undefined

  return (
    <React.Fragment>
      <SubGroupWrap
        onClick={toggleCollapse}
        center={center}
        isOpened={!isCollapsed}
      >
        <CollapsiblePanelTitle black book>
          {group}
        </CollapsiblePanelTitle>
        <ArrowIcon marginLeft rotation={rotationCondition} />
      </SubGroupWrap>
      <Collapse isOpened={isCollapsed}>{children}</Collapse>
    </React.Fragment>
  )
}

type Outter = {|
  children: React.Node,
  group: string,
  center?: boolean,
  open?: boolean,
|}

const enhancer: HOC<*, Outter> = compose(
  withStateHandlers(
    { isCollapsed: false },
    {
      toggleCollapse: props => () => ({ isCollapsed: !props.isCollapsed }),
    },
  ),
  withOnMount(props => {
    if (props.open) props.toggleCollapse()
  }),
)

export default enhancer(CollapsiblePanel)



// WEBPACK FOOTER //
// ./src/components/CollapsiblePanel/index.js